import { toast } from 'react-toastify';
import { getMessageFromI18nCatalog, getShortCodeFromLocale } from '../intl-helpers';

/**
 * Mostra un toast di successo con messaggio custom o fallback i18n
 * @param {string|null|undefined} message - Il messaggio da mostrare (se presente)
 * @param {string} userLocale - La locale dell'utente (es. 'it_IT')
 * @param {string} fallbackMsgId - L'id del messaggio i18n di fallback (default: 'success:generic')
 */
export function showSuccessToast(message, userLocale, fallbackMsgId = 'success:generic') {
    const language = getShortCodeFromLocale(userLocale);
    const messageFallback = getMessageFromI18nCatalog(language, fallbackMsgId);

    toast(message ?? messageFallback, {
        position: 'bottom-right',
        type: toast.TYPE.SUCCESS,
    });
}

/**
 * Mostra un toast di errore con messaggio custom o fallback i18n
 * @param {string|null|undefined} message - Il messaggio da mostrare (se presente)
 * @param {string} userLocale - La locale dell'utente (es. 'it_IT')
 * @param {string} fallbackMsgId - L'id del messaggio i18n di fallback (default: 'error:unexpected')
 */
export function showErrorToast(message, userLocale, fallbackMsgId = 'error:unexpected') {
    const language = getShortCodeFromLocale(userLocale);
    const messageFallback = getMessageFromI18nCatalog(language, fallbackMsgId);

    toast(message ?? messageFallback, {
        position: 'bottom-right',
        type: toast.TYPE.ERROR,
    });
}